import React, { useState, useCallback, useEffect, useRef } from 'react';
import {
  Drawer,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useStyles } from './cardapio-sacola-styles';
import { Sacola } from './componentes/fases/sacola/sacola';
import { DialogScannerComanda } from '../cardapio-scanner-comanda';
import classNames from 'classnames';
import { MovSimplesProdutoModel } from 'api/cardapio/models/produto/mov-simples-produto-model';
import { IdentificacaoCliente } from './componentes/fases/identificacao-cliente/identificacao-cliente';
import { EnumFasePagamento, FormasPagamento } from './componentes/fases/formas-pagamento/formas-pagamento';
import { PagamentoPix } from './componentes/fases/pagamento-pix/pagamento-pix';
import { FazendoPedido } from './componentes/fases/fazendo-pedido/fazendo-pedido';
import { isEmpty } from 'lodash';
import { CardapioDadosProps } from '../cardapio-header/cardapio-header-props';
import { ConfirmarInformacoes } from './componentes/fases/confirmar-informacoes/confirmar-informacoes';
import { useMovProd } from 'services/hooks/mov-prod';
import { usePedidos } from 'services/providers/pedidos-provider';
import { useSacolaAbertaStore } from 'services/store/sacola-aberta';
import { DialogAdicionarProdutoComSubItem } from 'components/dialogs/dialog-adicionar-produto-com-subitem/dialog-adicionar-produto-com-subitem';
import { VisualizarProdutoModal } from 'components/dialogs/visualizar-produto-modal';
import { InformarEndereco } from './componentes/fases/informar-endereco/informar-endereco';
import { CircularLoading } from 'components/utils/circular-loading';

export interface CarddapioSacolaProps {
  cardapioDados: CardapioDadosProps | undefined;
  mesaId: string;
  abrirModalCliente: () => void;
}

export enum EnumTipoBuild {
  Padaria,
  Shopping
}

export enum EnumFasesSacola {
  Nada,
  Sacola,
  IdentificarCliente,
  InformarEndereco,
  FormaPagamento,
  PagamentoPix,
  FazendoPedido,
  ConfirmarInformacoes
}

// const tipoBuild: EnumTipoBuild = TipoBuildEnv === "shopping" ? EnumTipoBuild.Shopping : EnumTipoBuild.Padaria

export const CardapioSacola = ({
  cardapioDados,
  mesaId,
  abrirModalCliente,
}: CarddapioSacolaProps) => {
  // DEPENDENCIAS
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const variant = isMobile ? 'temporary' : 'temporary';
  const anchor = isMobile ? 'bottom' : 'right';
  const empresaId = cardapioDados?.empresa.id ?? ''
  // REQUISIÇÕES
  const { adicionarProdutoComSubItem, editarProdutoComSubItem } = useMovProd()

  // STATES E REFS
  const [editarProdPedidoAberto, setEditarProdPedidoAberto] = useState(false);
  const [produto, setProduto] = useState<MovSimplesProdutoModel>(new MovSimplesProdutoModel())
  const [faseSacola, setFaseSacola] = useState<EnumFasesSacola>(EnumFasesSacola.Sacola)
  const [scannerComanda, setScannerComanda] = useState<boolean>(false)
  const [dialogSubitem, setDialogSubItem] = useState<boolean>(false)
  const editarUsuarioEnderecoRef = useRef<boolean>(false)
  const { setCodComanda, codComanda } = usePedidos()
  const voltarParaFaseFinalizarPedido = useRef<boolean>(false)
  const loadingInfoCliente = useRef<boolean>(true)
  const empresaDados = cardapioDados?.empresa
  const fecharSacola = useSacolaAbertaStore().fecharSacola
  const sacolaAberta = useSacolaAbertaStore((state) => state.sacolaAberta)
  const pagamentoNaFinalizacao = cardapioDados?.configuracoes.disponibilizarPagamentoFinalizacao === true
  const foiAbertoSacola = useRef<boolean>(false)
  const { getPedido, carregandoGetPedido } = usePedidos()



  const [fasesPagamento, setFasesPagamento] = useState<EnumFasePagamento>(EnumFasePagamento.SelecionarTipoPagamento)

  const tipoDelivery = [
    cardapioDados?.configuracoes?.permiteEntrega,
    cardapioDados?.configuracoes?.permiteRetirada
  ].includes(true)
  const deliveryHabilitado = cardapioDados?.configuracoesDelivery?.deliveryHabilitado ?? false

  useEffect(() => {
    if (sacolaAberta) setFaseSacola(EnumFasesSacola.Sacola)
  }, [sacolaAberta])


  const fecharEdicaoProduto = useCallback(() => {
    setEditarProdPedidoAberto(false);
    setTimeout(() => {
      setProduto(new MovSimplesProdutoModel())
    }, 100)
  }, []);


  useEffect(() => {
    document.body.classList.toggle(classes.scrollPage);
  }, [classes.scrollPage]);



  const entrarFases = useCallback((fase: EnumFasesSacola) => {
    setFaseSacola(EnumFasesSacola.Nada)
    setTimeout(() => {
      setFaseSacola(fase)
    }, 300)
  }, [])

  const editarItem = useCallback((item: MovSimplesProdutoModel) => {
    setProduto(item);
    if (item.subItens.length === 0) {
      setEditarProdPedidoAberto(true)
      return
    }
    setDialogSubItem(true)
  }, []);

  const handleCodigo = async (codigo: string) => {
    const prefixo = cardapioDados?.configuracoesEmpresa.find(x => x.codigo === 804)
    if (prefixo && prefixo.valor && codigo.startsWith(prefixo.valor)) {
      codigo = codigo.slice(prefixo.valor.length)
    }
    const pedido = await getPedido(codigo)
    setCodComanda(codigo)


    if (cardapioDados?.configuracoes.tipoUsoCardapio === 1 && !pedido) {
      entrarFases(EnumFasesSacola.IdentificarCliente)
      return
    }

    if (cardapioDados?.configuracoes.disponibilizarPagamentoFinalizacao) {
      entrarFases(EnumFasesSacola.FormaPagamento)
      return;
    }

    entrarFases(EnumFasesSacola.ConfirmarInformacoes)
  }

  const onClickProximaFase = useCallback((nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => {
    nextOrBack.current = 1

    setTimeout(() => {
      entrarFases(fase)
    }, 100)

    nextOrBack.current = 0
  }, [entrarFases])

  const onClickVoltarFase = useCallback((nextOrBack: React.MutableRefObject<0 | 1>, fase: EnumFasesSacola) => {
    nextOrBack.current = 0

    setTimeout(() => {
      entrarFases(fase)
    }, 100)

    nextOrBack.current = 1
  }, [entrarFases])

  const handlePedidoFluxo = useCallback((nextOrBack: React.MutableRefObject<0 | 1>) => {
    if (mesaId) {
      if (cardapioDados?.configuracoes.tipoUsoCardapio === 1 && isEmpty(codComanda)) {
        setScannerComanda(true)
        return
      }
    }

    if (!mesaId) {
      onClickProximaFase(nextOrBack, EnumFasesSacola.FormaPagamento)
      return
    }

    if (mesaId && pagamentoNaFinalizacao) {
      onClickProximaFase(nextOrBack, EnumFasesSacola.FormaPagamento)
      return
    }

    onClickProximaFase(nextOrBack, EnumFasesSacola.ConfirmarInformacoes)
  }, [mesaId, pagamentoNaFinalizacao, onClickProximaFase, cardapioDados?.configuracoes.tipoUsoCardapio, codComanda])


  // Push a history state when sacola opens so that a back action stays on page and triggers our handler
  useEffect(() => {
    if (!sacolaAberta) return;
    try {
      window.history.pushState({ sacolaOverlay: true }, document.title);
    } catch { }
  }, [sacolaAberta])

  return (
    <>
      <Drawer
        variant={variant}
        anchor={anchor}
        open={sacolaAberta}
        classes={{ paper: classNames(classes.drawer) }}
        style={{
          overflowX: 'hidden',
          position: 'relative'
        }}
      >
        {carregandoGetPedido && <CircularLoading tipo="FULLSIZED" titulo="Aguarde..." />}
        {/* <div className={isMobile ? classes.drawerBg : ''}></div> */}
        <div className={classes.container}>
          <Sacola
            quandoFechado={fecharSacola}
            foiAbertoSacola={foiAbertoSacola}
            empresaId={empresaId}
            cardapioDados={cardapioDados}
            abrirModalCliente={abrirModalCliente}
            mesaId={mesaId}
            sacolaAberta={sacolaAberta}
            editarItem={editarItem}
            faseSacola={faseSacola}
            handlePedidoFluxo={handlePedidoFluxo}
            configEmp={cardapioDados?.configuracoesEmpresa ?? []}
            pedidoDelivery={deliveryHabilitado}
            onClickProximaFase={onClickProximaFase}
            onClickVoltarFase={onClickVoltarFase}
          />
          <IdentificacaoCliente
            mesaId={mesaId}
            handlePedidoFluxo={handlePedidoFluxo}
            faseSacola={faseSacola}
            fecharSacola={fecharSacola}
            tipoDelivery={tipoDelivery}
            pedidoDelivery={deliveryHabilitado}
            editarUsuarioEnderecoRef={editarUsuarioEnderecoRef.current}
            onClickProximaFase={onClickProximaFase}
            onClickVoltarFase={onClickVoltarFase}
            voltarParaFaseFinalizarPedido={voltarParaFaseFinalizarPedido}
            loadingInfoCliente={loadingInfoCliente}
          />
          <InformarEndereco
            foiAbertoSacola={foiAbertoSacola}
            faseSacola={faseSacola}
            fecharSacola={fecharSacola}
            onClickProximaFase={onClickProximaFase}
            onClickVoltarFase={onClickVoltarFase}
            voltarParaFaseFinalizarPedido={voltarParaFaseFinalizarPedido}
          />
          <FormasPagamento
            faseSacola={faseSacola}
            fecharSacola={fecharSacola}
            empresaId={empresaId}
            cardapioDados={cardapioDados}
            mesaId={mesaId}
            onClickProximaFase={onClickProximaFase}
            onClickVoltarFase={onClickVoltarFase}
            fasesPagamento={fasesPagamento}
            setFasesPagamento={setFasesPagamento}
            voltarParaFaseFinalizarPedido={voltarParaFaseFinalizarPedido}
          />
          <PagamentoPix
            faseSacola={faseSacola}
            fecharSacola={fecharSacola}
            onClickProximaFase={onClickProximaFase}
            onClickVoltarFase={onClickVoltarFase}
          />
          <FazendoPedido
            faseSacola={faseSacola}
            fecharSacola={fecharSacola}
            setScannerComanda={setScannerComanda}
            handlePedidoFluxo={handlePedidoFluxo}
            onClickProximaFase={onClickProximaFase}
            onClickVoltarFase={onClickVoltarFase}
          />
          <ConfirmarInformacoes
            onClickProximaFase={onClickProximaFase}
            onClickVoltarFase={onClickVoltarFase}
            faseSacola={faseSacola}
            handlePedidoFluxo={handlePedidoFluxo}
            setFasesPagamento={setFasesPagamento}
            loadingInfoCliente={loadingInfoCliente}
            empresaDados={empresaDados}
            mesaId={mesaId}
            pagamentoNaFinalizacao={pagamentoNaFinalizacao}
            voltarParaFaseFinalizarPedido={voltarParaFaseFinalizarPedido}
          />
        </div>
      </Drawer>
      <VisualizarProdutoModal
        aberto={editarProdPedidoAberto}
        produto={produto}
        mesaId={mesaId}
        quandoForFechado={fecharEdicaoProduto}
        permiteEntrega={cardapioDados?.configuracoes.permiteEntrega}
        permiteRetirada={cardapioDados?.configuracoes.permiteRetirada}
        fone={cardapioDados?.empresa.fone}
      />

      {scannerComanda && (
        <DialogScannerComanda
          openned={scannerComanda}
          statusPedido={false}
          closeModal={() => setScannerComanda(false)}
          cardapioDados={cardapioDados}
          empresaId={empresaId}
          mesaId={mesaId}
          handleCodigo={handleCodigo}
        />
      )}

      {dialogSubitem && (
        <DialogAdicionarProdutoComSubItem
          aberto={dialogSubitem}
          adicionarProdutoComSubItem={adicionarProdutoComSubItem}
          editarProdutoComSubItem={editarProdutoComSubItem}
          fechar={() => setDialogSubItem(false)}
          produto={produto}
          mesaId={mesaId}
          edit
        />
      )}
    </>
  );
};
